// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2cMT1","inputWrap":"Table_inputWrap__12R5T","col":"Table_col__309_M","bmiTooltip":"Table_bmiTooltip__paMuM"};